export default __webpack_public_path__ + "static/media/ic_kiribati.9ae31c25.svg";